import React from 'react';

import './spinner.scss';

interface SpinnerProps {
  color?: string;
}

export function Spinner({ color = 'white' }: SpinnerProps) {
  return (
    <div className={`ispinner ispinner--animating ispinner--${color}`}>
      <div className='ispinner__blade blade1' />
      <div className='ispinner__blade blade2' />
      <div className='ispinner__blade blade3' />
      <div className='ispinner__blade blade4' />
      <div className='ispinner__blade blade5' />
      <div className='ispinner__blade blade6' />
      <div className='ispinner__blade blade7' />
      <div className='ispinner__blade blade8' />
    </div>
  );
}
